import { createAppointmentTask } from "api/Appointment";
import { useMutation, useQueryClient } from "react-query";
import { toast } from "react-toastify";

export const useCreateAppointmentTask = () => {
    const queryClient = useQueryClient();

    return useMutation(createAppointmentTask, {
        onSuccess: () => {
            toast.success("Task Created Successfully");
            queryClient.invalidateQueries(['widgetData', 'Appointment Pendings List'])

        },
        onError: () => {
            toast.error("Something went wrong");
        },
    });
};
